import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as taskService from '_services/task'
import * as todayItemsService from '_services/today-items'

export const GET_TASKS = defineAction('GET_TASKS')
export const GET_TASK = defineAction('GET_TASK')
export const CREATE_FROM_TODAY = defineAction('CREATE_FROM_TODAY')
export const ADD_TASK = defineAction('ADD_TASK')
export const DELETE_TASK = defineAction('DELETE_TASK')

export const getTasks = () => (dispatch, getState) =>
  dispatch({
    type: GET_TASKS.ACTION,
    payload: taskService.getTasks(getState().user.get('token')),
  })

export const getTask = id => (dispatch, getState) =>
  dispatch({
    type: GET_TASK.ACTION,
    payload: taskService.getTask(getState().user.get('token'), { id }),
  })

export const createLogEntryFromToday = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_FROM_TODAY.ACTION,
    payload: todayItemsService
      .completeTodayItem(getState().user.get('token'))(payload)
      .then(() => taskService.getTasks(getState().user.get('token'))),
  })

export const addToLog = payload => (dispatch, getState) =>
  dispatch({
    type: ADD_TASK.ACTION,
    payload: taskService
      .addTask(getState().user.get('token'))(payload)
      .then(() => taskService.getTasks(getState().user.get('token'))),
  })

export const deleteFromLog = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_TASK.ACTION,
    payload: taskService
      .deleteTask(getState().user.get('token'))(payload)
      .then(() => payload.taskId),
  })



// WEBPACK FOOTER //
// ./src/modules/log/actions.js